import React, { useRef, useState } from "react";
import { Tooltip, Popover } from "@mui/material";
import { IconButton } from "@mui/material";
import AsiaCup2025 from '../../../images/AsiaCup2025.png'

const MessageA1 = (props) => {
  const [clicked, setClicked] = useState(false);

  const onClickHandler = (e) => {
    if (!props.disable) {
      props.handleClick(props.item.code);
      props.setTextOnClick(props.item.text);
      props.setSubTextOnClick(props?.item?.infoText || '')
      setClicked(true);
    }
  };
  const checkButton = () => {
    let userText = props?.item?.text;
    const buttonTextOptions = ["Yes", "No", "Submit", "Confirm", "Send OTP", "Got it"];
  
    return buttonTextOptions.includes(userText);
  };


  return (
    <>
       {props?.item?.infoText && props?.item?.text != "Chat with us" ? (
      <Tooltip
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1 style={{ fontSize: 13, margin: 0 }}>{props?.item?.infoText}</h1>
        </div>
      }
      placement="top"
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "preventOverflow",
            options: { boundary: "window" },
          },
          {
            name: "offset",
            options: { offset: [0, -5] },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "rgba(34, 0, 70, 0.75);",
            color: "#fff",
            fontSize: "12px",
            padding: "6px 10px",
          },
        },
        arrow: {
          sx: {
            color: "rgba(34, 0, 70, 0.75);",
          },
        },
      }}
    >
      {(() => {
        let extraClass = "";
        let dynamicColor = "";
        try {
          const parsed = JSON.parse(props?.item?.data || "{}");
          if (parsed?.color) {
            dynamicColor = parsed.color;
            extraClass = "dynamic-colored-btn";
          }
        } catch {}
        return (
          <button
            className={
              `${!props.disable ? "chat-label action-tab" : "chat-labelnohover action-tab"} ${extraClass}`
            }
            id="main-tab1"
            style={{
              color: clicked && "grey",
              pointerEvents: clicked && "none",
              ...(dynamicColor && { "--dynamic-bg": dynamicColor }), // pass value to CSS var
            }}
            onClick={onClickHandler}
          >
            {props.item.text}
          </button>
        );
      })()}
    </Tooltip>
    
    
     
      
      
      ) : props?.isFallback && props?.item?.text === "Chat with us" ? (
        <>
          <button
            className={
              props.isFallback
                ? "chat-label-fallback action-tab"
                : "chat-labelnohover action-tab"
            }
            id="main-tab1"
            style={{
              color: clicked && "grey",
              pointerEvents: clicked && "none",
            }}
            onClick={onClickHandler}
          >
            {props?.item?.text}
          </button>
        </>
      ) :props?.item?.text === "Chat with us"?(
      <>
        <button
          // className={"chat-label-fallback" }
          className='chat-label-fallback action-tab disabled-white'
          id="main-tab1"
          style={{
            pointerEvents: clicked && "none",
            cursor :clicked && "not-allowed",
            color: clicked && "white",
            opacity: clicked && "0.5",
          }}
          onClick={onClickHandler}
        >
          {props?.item?.text}
        </button>
      </>
      ):(
        <button
  className={
    props.isFallback
      ? "chat-label action-tab"
      : `${props?.item?.text === "Upload Image" ? "chat-label-fallback action-tab" : "chat-label action-tab"} `
  }
  id="main-tab1"
  style={{
    color: clicked && "grey",
    pointerEvents: clicked && "none",
    borderRadius: checkButton() ? "4px" : "44px",
    position: "relative",
    overflow: "visible", // allow badge outside
    paddingRight: "16px", // some breathing room
  }}
  onClick={onClickHandler}
>
    {(() => {
        try {
        const parsed = JSON.parse(props?.item?.data || "{}");
        if (parsed?.img) {
            return (
                <img
                src={parsed?.img}
                alt={props?.item?.text}
                style={{
                  width: "24px",
                  height: "24px",
                  opacity: 0.9,
                  mixBlendMode: "darken", // blends white with background
                }}
              />
              
            );
        }
        } catch {
        return null;
        }
        return null;
    })()}
  {props?.item?.text}

  {/* NEW Tag */}
  {(() => {
    try {
      const parsed = JSON.parse(props?.item?.data || "{}");
      return parsed?.button === "new"  ? (
        <span
          style={{
            position: "absolute",
            top: "-12px",    // move above button
            right: "4px",    // align with right corner
            background: "red",
            color: "white",
            fontSize: "10px",
            fontWeight: "bold",
            padding: "2px 6px",
            borderRadius: "10px",
            whiteSpace: "nowrap",
            marginLeft:'6px'
          }}
        >
          NEW
        </span>
      ) : null;
    } catch {
      return null;
    }
  })()}
</button>

      
      

      

      
      )}
    </>
  );
};

export default MessageA1;
